const Houses = (props) => (
		//<?xml version="1.0" encoding="utf-8"?><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
		<svg fill="currentColor" width={24}
			 height={24} viewBox="0 0 512.004 512.004" xmlns="http://www.w3.org/2000/svg">
			<path d="M490.264,397.448h-15.218V248.529c4.348,3.261,8.696,5.435,14.131,5.435
			c6.522,0,11.957-2.174,17.392-6.522c7.609-8.696,6.522-22.827-2.174-30.436L347.866,76.782c-7.609-7.609-20.653-7.609-28.262,0
			l-64.498,57.126l-63.769-57.126c-7.609-7.609-20.653-7.609-28.262,0L7.635,215.919c-9.783,8.696-9.783,21.74-2.174,30.436
			c7.609,9.783,21.74,9.783,30.436,2.174v148.919H21.766c-11.957,0-21.74,9.783-21.74,21.74c0,11.957,9.783,21.74,21.74,21.74
			h35.871h156.528h82.612h156.528h35.871c11.957,0,22.827-9.783,22.827-21.74C512.004,407.231,502.221,397.448,490.264,397.448z
			 M79.377,209.397l97.83-88.047l97.83,87.375v188.724h-60.872H79.377V209.397z M318.517,397.448v-149.89l1.087,0.971
			c4.348,3.261,8.696,5.435,14.131,5.435s11.957-2.174,16.305-6.522c7.609-8.696,6.522-22.827-2.174-30.436l-60.483-54.183
			l46.352-41.473l97.83,88.047v188.051H318.517z"/>
		</svg>
	)
;

export default Houses;